var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{class:['layout h-full', _vm.device$d]},[_c('a-layout-content',{staticClass:"flex h-full"},[_c('side-s-menu',{attrs:{"menus":_vm.menus}}),_c('div',{staticClass:"content-main-holder"},[_c('transition',{attrs:{"name":"page-transition"}},[_c('KeepAliveRouterView')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }